import m from "mithril";
import loaderclass from "../components/loader-success-fail/loader-success-fail.js";
import {Overlay} from "../../old/tools/constructui";

export default () => {
	let showloader = false;
	let loader = loaderclass();
	const createcontent = () => {
		return loader.Component();
	};

	const RunWhileLoaderShows = async (func) => {
		showloader = true;
		const {success, message} = await func();
		await loader.MarkComplete(success, message);
		showloader = false;
	};

	return {
		overlay: () => {
			return m(Overlay, {
				backdropClass: "custom-action-button-status-backdrop",
				closeOnEscapeKey: false,
				closeOnOutsideClick: false,
				hasBackdrop: true,
				inline: false,
				content: createcontent(),
				isOpen: showloader,
				transitionDuration: 5,
			});
		},
		RunFunction: async (func) => {
			return await RunWhileLoaderShows(func);
		},
	};
};
